import { createListStore } from "./list";
import { DatapointService } from "@/services/datapoints";

export const useDatapointsStore = createListStore(
  "datapoints",
  DatapointService
);
